import React from 'react';
import styled from 'styled-components';

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="none" viewBox="0 0 19 19">
      <Path d="M4.392 10.756l3.712 3.712 6.187-6.187-3.712-3.713-6.187 6.188zm9.59-5.878a1.24 1.24 0 01-.387-.928c0-.348.116-.658.387-.928l-1.856-1.856c-.252-.252-.561-.368-.928-.387-.368.02-.677.135-.928.387l-9.281 9.28c-.271.271-.387.58-.387.928 0 .387.135.677.387.928l1.856 1.857c.251-.252.56-.368.928-.387.367.02.677.135.928.387.27.27.387.58.387.928 0 .386-.136.676-.387.928l1.856 1.856c.27.27.56.406.928.387.368.019.658-.116.928-.387l9.281-9.28c.252-.252.387-.542.387-.929 0-.348-.116-.657-.387-.928l-1.856-1.856c-.27.27-.56.406-.928.387-.367.019-.658-.116-.928-.387zm-2.94-1.083l4.023 4.022a.66.66 0 01.193.464.64.64 0 01-.193.464L8.568 15.24c-.135.136-.29.213-.464.194-.174.02-.329-.058-.464-.194L3.618 11.22a.64.64 0 01-.193-.464.66.66 0 01.193-.464l6.497-6.497c.116-.116.29-.174.464-.193.174.02.348.077.464.193z" />
    </svg>
  );
}

export default Icon;

const Path = styled.path`
  fill: ${(props) => props.theme.buttonColor || '#fff'};
`;
